<template>
  <div class="intervento-dettaglio">

        <div class="row pad" >
        <div class="col s12 m3 l1 yo-align-right" v-if="evento.inizio!=evento.fine">{{ evento.giorno+' '+evento.inizio  | datetime('HH:mm') }} - {{ evento.giorno+' '+evento.fine  | datetime('HH:mm') }}</div>
        <div class="col s12 m3 l1 yo-align-right" v-if="evento.inizio==evento.fine">&#160;</div>
        <div class="col s12 m9 l11" >
          <div class="yo-text-bold">{{evento.titolo}}</div>

          <interventoOspiti :programma="evento.id" ruolo="relatore"/>
        </div>
        </div>

        

<!--
        <div class="row" v-if="evento.ospiti">
        <div class="col s12 m2 l1">&#160;</div>
        <div class="col s12 m10 l11"><span class="ospite" v-for="ospite in evento.ospiti">{{ospite.nome}} {{ospite.cognome}}{{ospite.workcitta | citta}}</span></div>
        </div>
        <div v-if="evento.note!=''" class="col s12 m2 l1">&#160;</div>
        <div v-if="evento.note!=''" class="col s12 m10 l11"  v-html="evento.note"></div>
        <br  v-if="evento.note!=''" />

        <div class="row intervento-dettaglio-child" v-for="intervento in finterventi(evento.id)">
        <div class="col s12 m2 l1">&#160;</div>
        <div class="col s12 m10 l11">
            {{intervento.titolo}}
            <br />
            <span class="ospite" v-for="ospite in intervento.ospiti">{{ospite.nome}} {{ospite.cognome}}{{ospite.workcitta | citta}}</span>
            <div v-if="intervento.note!=''" v-html="intervento.note"></div>
        </div>
        </div>

     -->   

  </div>
</template>

<script>
import interventoOspiti from './Intervento-ospiti.vue'

var moment = require('moment');
moment.locale('en');
export default {
  name: 'intervento-dettaglio',
  components: {
    interventoOspiti
  },
  props:{
    evento: {}
  },
  computed: { 
      sezione: function () {
        if(this.$route.params.sezione=='')
          return this.$teras._programma
        var isFilter = []

      
        for (let item of this.$teras._programma){
            if(item.giorno.toLowerCase().indexOf(this.giorno) > -1 && 
                (item.mainsession.toLowerCase().indexOf(this.$route.params.sezione.toLowerCase()) > -1 
                || item.tiposessione.toLowerCase().indexOf(this.$route.params.sezione.toLowerCase()) > -1 
                || item.tiposessione.toLowerCase().indexOf(this.$route.params.sezione.toLowerCase()) > -1
                )
            )
            isFilter.push(item)
        }
        return isFilter
      }
      
  },
  methods:{
    finterventi(id){
        var isFilter = []
        for (let item of this.$teras.interventi){
            console.log(item)
            if(item.parent == id)
                isFilter.push(item)
        }
        return isFilter
    }
  },
  filters: {
    datetime (value,formato) {
        return moment(value).format(formato)
    },
    citta (value) {
        if(value!=''){
            value = ' ('+value+')'
        }
        return value
    }
  }
}
</script>


<style>
.intervento-dettaglio{
    margin-bottom:20px;
    cursor:pointer;
}span.ospite:not(:last-child):after {
    content:', ';
}.intervento-dettaglio-child{
    margin-top:10px;
}

</style>
